import axios from 'axios';
import {extend} from 'lodash';

// Get API resource URL with fallback
const getApiBaseUrl = () => {
  // Check if window.env exists and has apiResource property
  if (window.env && window.env.apiResource) {
    return window.env.apiResource;
  }

  // Fallback URL - use a relative path or your development API URL
  // This prevents the "Cannot read properties of undefined" error
  return '/api';
};

/** Handle ajax requests */
const api = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 30000,
  headers: {
    post: {
      'Content-Type': 'application/json',
    },
    common: {
      'Accept': 'application/json', // eslint-disable-line quote-props
    },
  },
});

api.interceptors.response.use((response) => {
  // Do something with response data
  return response;
}, (error) => {
  if (window.Rollbar) {
    window.Rollbar.error('React error', [error]);
  }

  return Promise.reject(error);
});

export default api;

export function setApiDefaults(defaults, api) {
  (api || axios).defaults = extend(axios.defaults, defaults);
}
